export const getTwTargetCurrency = state => state.transferWiseQuoteReducer.targetCurrency;
